{
  "tabs": {
    "chat": "చాట్",
    "reminders": "మరచిపోకూడదు",
    "calendar": "క్యాలెండర్",
    "settings": "సెట్టింగ్స్"
  },
  "common": {
    "cancel": "రద్దు చేయి",
    "save": "సేవ్ చేయి",
    "confirm": "నిర్ధారించు",
    "delete": "తొలగించు",
    "back": "వెనక్కి",
    "close": "మూసివేయి",
    "edit": "సవరించు",
    "search": "శోధించు",
    "all": "అన్నీ",
    "loading": "లోడ్ అవుతోంది...",
    "error": "ఏదో తప్పు జరిగింది",
    "notFound": "కనుగొనలేదు",
    "tryAgain": "దయచేసి మళ్లీ ప్రయత్నించండి",
    "retry": "మళ్లీ ప్రయత్నించు",
    "undo": "తిరిగి తీసుకో",
    "pullToRefresh": "తాజా చేయడానికి తీయండి",
    "justNow": "ఇప్పుడే"
  },
  "auth": {
    "welcome": "FishMemoryకి స్వాగతం",
    "tagline": "మీ WhatsApp రిమైండర్ సహాయకుడు, ఇప్పుడు మీ జేబులో.",
    "subtitle": "మీ WhatsApp రిమైండర్ సహాయకుడు, ఇప్పుడు మీ జేబులో.",
    "phoneLabel": "మీ WhatsApp నంబర్",
    "phoneHint": "WhatsApp ద్వారా ధృవీకరణ కోడ్ పంపబడుతుంది",
    "invalidPhone": "దయచేసి సరైన ఫోన్ నంబర్ ఇవ్వండి",
    "continue": "కొనసాగించు",
    "enterPhone": "మీ WhatsApp నంబర్ నమోదు చేయండి",
    "phonePlaceholder": "ఫోన్ నంబర్",
    "sendCode": "కోడ్ పంపు",
    "verifyTitle": "మీ నంబర్ ధృవీకరించండి",
    "otpSentTo": "{{phone}} కు WhatsApp ద్వారా 6 అంకెల కోడ్ పంపబడింది",
    "enterFullCode": "దయచేసి అన్ని 6 అంకెలను నమోదు చేయండి",
    "invalidOtp": "చెల్లని కోడ్. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "otpFailed": "కోడ్ పంపడంలో విఫలం. మళ్లీ ప్రయత్నించండి.",
    "otpResent": "కోడ్ మళ్లీ పంపబడింది",
    "resendIn": "{{seconds}} సెకన్లలో మళ్లీ పంపండి",
    "resendCode": "కోడ్ మళ్లీ పంపు",
    "enterOtp": "మీ WhatsAppకు పంపబడిన కోడ్ నమోదు చేయండి",
    "verify": "ధృవీకరించు",
    "resend": "కోడ్ మళ్లీ పంపు",
    "wrongNumber": "తప్పు నంబర్?",
    "backToPhone": "ఫోన్‌కు వెనక్కి",
    "editPhone": "ఫోన్ నంబర్ సవరించు",
    "error": "లోపం",
    "setupTitle": "సెట్టింగ్ ప్రారంభిద్దాం",
    "setupSubtitle": "మీరు ఎప్పుడైనా సెట్టింగ్స్‌లో మార్చుకోవచ్చు",
    "namePlaceholder": "మీ పేరు",
    "letsGo": "సెట్టప్ పూర్తి చేయి",
    "skipForNow": "ఇప్పుడే దాటవేయి"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "సందేశం టైప్ చేయండి...",
    "inputPlaceholder": "సందేశం టైప్ చేయండి...",
    "typing": "FishMemory టైపింగ్ చేస్తోంది...",
    "online": "ఆన్లైన్",
    "connecting": "కనెక్ట్ అవుతోంది...",
    "reconnecting": "మళ్లీ కనెక్ట్ అవుతోంది...",
    "offline": "ఆఫ్లైన్",
    "empty": "సంభాషణ ప్రారంభించండి",
    "emptyHint": "రిమైండర్లు సృష్టించండి, షెడ్యూల్ చూడండి, లేదా సహాయం అడగండి.",
    "emptyAction": "ఉదాహరణ రిమైండర్ పంపండి",
    "actions": "చాట్ చర్యలు",
    "keep": "సందేశాలు ఉంచు",
    "clearTitle": "చాట్ క్లియర్ చేయి",
    "clearConfirm": "ఈ పరికరం నుండి అన్ని సందేశాలను తొలగించాలా? ఇది తిరిగి రాదు.",
    "clear": "చాట్ క్లియర్ చేయి",
    "optionSelected": "ఎంచుకున్నది: {{label}}",
    "sendingSelection": "పంపుతోంది...",
    "connectionLost": "మళ్లీ కనెక్ట్ అవుతోంది..."
  },
  "reminders": {
    "title": "నా రిమైండర్లు",
    "active": "సక్రియం",
    "today": "ఈ రోజు",
    "thisWeek": "ఈ వారం",
    "history": "చరిత్ర",
    "items": "అంశాలు",
    "emptyTitle": "ఇంకా రిమైండర్లు లేవు",
    "emptySubtitle": "చాట్ నుండి ఒకటి సృష్టించండి, ఇది ఇక్కడ కనిపిస్తుంది.",
    "emptyAction": "చాట్ తెరవండి",
    "filterActive": "సక్రియం",
    "filterToday": "ఈ రోజు",
    "filterWeek": "ఈ వారం",
    "filterHistory": "చరిత్ర",
    "emptyState": "ఇంకా రిమైండర్లు లేవు. చాట్ ప్రారంభించండి!",
    "swipeDone": "పూర్తయింది",
    "swipeSnooze": "స్నూజ్",
    "swipeDelete": "తొలగించు",
    "search": "రిమైండర్లు శోధించండి...",
    "upcoming": "రాబోయే",
    "completed": "పూర్తయింది",
    "overdue": "వాయిదా పడ్డవి",
    "tomorrow": "రేపు",
    "synced": "సింక్ అయింది {{value}}",
    "swipeHint": "చర్యల కోసం రిమైండర్‌ను స్వైప్ చేయండి",
    "noResults": "మీ శోధనకు సరిపోయే రిమైండర్లు లేవు",
    "noResultsHint": "వేరే పదం ప్రయత్నించండి లేదా శోధన క్లియర్ చేయండి",
    "deleteAllFailed": "అన్ని రిమైండర్లు తొలగించడంలో విఫలం"
  },
  "calendar": {
    "title": "క్యాలెండర్",
    "today": "ఈ రోజు",
    "tomorrow": "రేపు",
    "completed": "పూర్తయింది",
    "noEvents": "ఏమీ షెడ్యూల్ చేయలేదు",
    "noEventsSubtitle": "రిమైండర్లు మరియు క్యాలెండర్ ఈవెంట్స్ చూడడానికి తేదీ ఎంచుకోండి.",
    "googleEvent": "Google క్యాలెండర్",
    "legendActive": "సక్రియం",
    "legendRecurring": "పునరావృతం",
    "legendDone": "పూర్తయింది",
    "legendGoogle": "Google",
    "previousMonth": "గత నెల",
    "nextMonth": "తరువాతి నెల",
    "previousYear": "గత సంవత్సరం",
    "nextYear": "తరువాతి సంవత్సరం",
    "goToToday": "ఈ రోజు కి వెళ్ళు",
    "all": "అన్నీ",
    "active": "సక్రియం",
    "done": "పూర్తయింది",
    "paused": "విరామం"
  },
  "settings": {
    "title": "సెట్టింగ్స్",
    "profile": "ప్రొఫైల్",
    "name": "ప్రదర్శన పేరు",
    "enterName": "మీ పేరు నమోదు చేయండి",
    "language": "భాష",
    "uiLanguage": "యాప్ భాష",
    "uiLanguageHelp": "ఈ పరికరంలో యాప్ UI, క్యాలెండర్ లేబుల్స్ మరియు లేఅవుట్ దిశ మార్చబడుతుంది.",
    "serverLanguage": "చాట్ భాష",
    "serverLanguageHelp": "మీ ఖాతాకు సర్వర్ సమాధానాలు మరియు రిమైండర్ సందేశాలకు ఉపయోగించే భాష మార్చబడుతుంది.",
    "timezone": "సమయ మండలం",
    "currentTimezone": "ప్రస్తుత సమయ మండలం",
    "timezoneHelp": "అన్ని రిమైండర్ సమయాలు ఈ సమయ మండలంతో చూపబడతాయి.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "సమయ మండలం సేవ్ చేయి",
    "timezoneSaved": "సమయ మండలం నవీకరించబడింది",
    "detect": "గుర్తించు",
    "detectFailed": "సమయ మండలం గుర్తించలేకపోయింది",
    "autoDetect": "GPS నుండి ఆటో గుర్తింపు",
    "notifications": "నోటిఫికేషన్లు",
    "notificationsHelp": "ఫాలో-అప్ రిమైండర్లు రిమైండర్ డెలివరీ తర్వాత పునరావృత అలర్ట్‌లను నియంత్రిస్తాయి. పరికరం స్థాయి నోటిఫికేషన్ అనుమతులు మీ ఫోన్ సెట్టింగ్స్‌లోనే నిర్వహించబడతాయి.",
    "pushEnabled": "పుష్ నోటిఫికేషన్లు",
    "autoDoneOnFire": "ఫైర్ అయినప్పుడు ఆటోమేటిక్ పూర్తి గుర్తు",
    "autoDoneOnFireDesc": "ఆఫ్ అయితే, మీరు పూర్తి చేసినట్లు గుర్తు చేసే వరకు రిమైండర్లు సక్రియంగా ఉంటాయి.",
    "googleCalendar": "Google క్యాలెండర్",
    "google": "Google క్యాలెండర్",
    "googleConnected": "కనెక్ట్ అయింది",
    "googleDisconnected": "కనెక్ట్ కాలేదు",
    "googleConnectedHelp": "కొత్త రిమైండర్లు మీ క్యాలెండర్‌కు ఆటోమేటిక్‌గా సింక్ చేయబడవచ్చు.",
    "googleDisconnectedHelp": "రిమైండర్లు మరియు ఈవెంట్లు సరిచేయడానికి Google క్యాలెండర్ కనెక్ట్ చేయండి.",
    "googleConnectFailed": "Google క్యాలెండర్ కనెక్ట్ చేయడంలో విఫలం",
    "connected": "కనెక్ట్ అయింది",
    "disconnected": "కనెక్ట్ కాలేదు",
    "connect": "కనెక్ట్ చేయి",
    "disconnect": "డిస్కనెక్ట్ చేయి",
    "autoSync": "కొత్త రిమైండర్లు ఆటో సింక్",
    "autosync": "కొత్త రిమైండర్లు ఆటో సింక్",
    "subscription": "సబ్స్క్రిప్షన్",
    "trialUsed": "ట్రయల్: {{used}}/{{total}} ఉపయోగించబడింది",
    "trialStatus": "ట్రయల్ అందుబాటులో ఉంది",
    "activeStatus": "సక్రియ సబ్స్క్రిప్షన్",
    "expiredStatus": "సబ్స్క్రిప్షన్ కాలం ముగిసింది",
    "unsubscribedStatus": "సబ్స్క్రైబ్ కాలేదు",
    "about": "గురించి",
    "version": "వర్షన్",
    "logout": "లాగ్ అవుట్",
    "logoutTitle": "లాగ్ అవుట్",
    "logoutConfirm": "మీరు నిజంగా లాగ్ అవుట్ కావాలనుకుంటున్నారా?",
    "noName": "పేరు సెట్ చేయబడలేదు",
    "serverConnection": "సర్వర్ కనెక్షన్",
    "serverUrl": "సర్వర్ URL",
    "serverEdit": "సవరించు",
    "saveReconnect": "సేవ్ చేసి మళ్లీ కనెక్ట్ అవ్వండి",
    "resetDefault": "డిఫాల్ట్‌కు రీసెట్ చేయి",
    "invalidServerUrlTitle": "చెల్లని సర్వర్ URL",
    "invalidServerUrlMessage": "దయచేసి సరైన http లేదా https సర్వర్ URL ఇవ్వండి, ఉదా: https://example.com",
    "uiLanguageChangeFailed": "యాప్ భాష మార్చడంలో విఫలం. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "serverLanguageChangeFailed": "చాట్ భాష మార్చడంలో విఫలం. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "timezoneChangeFailed": "సమయ మండలం మార్చడంలో విఫలం. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "autoSyncChangeFailed": "ఆటో-సింక్ నవీకరించడంలో విఫలం. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "nameChangeFailed": "ప్రదర్శన పేరు నవీకరించడంలో విఫలం. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "రిమైండర్ వివరాలు",
    "editTime": "సమయం సవరించు",
    "rename": "పేరును మార్చు",
    "snooze": "స్నూజ్ చేయి",
    "snooze15": "15 నిమిషాలు స్నూజ్ చేయి",
    "pause": "విరామం",
    "pauseReminder": "రిమైండర్ విరామం",
    "resume": "పునఃప్రారంభించు",
    "resumeReminder": "రిమైండర్ పునఃప్రారంభం",
    "skip": "తర్వాతి దాన్ని దాటవేయి",
    "skipOccurrence": "ఈ సందర్భాన్ని దాటవేయి",
    "syncGoogle": "Googleకి సింక్ చేయి",
    "delete": "తొలగించు",
    "deleteTitle": "రిమైండర్ తొలగించు",
    "deleteConfirm": "ఈ రిమైండర్ శాశ్వతంగా తొలగించబడుతుంది.",
    "deleteRecurringTitle": "పునరావృత రిమైండర్ తొలగించు",
    "deleteRecurringMessage": "ఈ సందర్భాన్ని దాటవేయాలా లేదా మొత్తం సిరీస్‌ను తొలగించాలా?",
    "deleteThisOccurrence": "ఈ సందర్భాన్ని దాటవేయి",
    "deleteEntireSeries": "మొత్తం సిరీస్ తొలగించు",
    "done": "పూర్తయింది",
    "markDone": "పూర్తయినట్లు గుర్తించు",
    "undo": "పునరుద్ధరించు",
    "undoPrompt": "మళ్లీ సక్రియం కావాలా? ఇప్పుడే పునరుద్ధరించండి.",
    "recurring": "పునరావృతం",
    "nextRun": "తర్వాతి రన్",
    "oneTime": "ఒకసారి",
    "pending": "పెండింగ్",
    "sent": "పంపబడింది",
    "paused": "విరామంలో",
    "active": "సక్రియం",
    "snoozed": "స్నూజ్ చేయబడింది",
    "localTime": "మీ స్థానిక సమయంతో చూపబడింది",
    "recurrence": "పునరావృతం",
    "created": "సృష్టించబడింది",
    "tags": "ట్యాగ్లు",
    "fireCount": "సార్లు ఫైర్ అయింది",
    "actions": "చర్యలు",
    "none": "ఏమీ లేదు",
    "snoozeFailed": "రిమైండర్ స్నూజ్ చేయడంలో విఫలం",
    "pauseFailed": "రిమైండర్ విరామం లోపించింది",
    "resumeFailed": "రిమైండర్ పునఃప్రారంభం లోపించింది",
    "skipFailed": "రిమైండర్ దాటవేయడంలో విఫలం",
    "doneFailed": "రిమైండర్ పూర్తి గుర్తించడంలో విఫలం",
    "undoFailed": "రిమైండర్ స్థితి పునరుద్ధరించడంలో విఫలం",
    "deleteFailed": "రిమైండర్ తొలగించడంలో విఫలం",
    "rescheduleTitle": "మళ్లీ షెడ్యూల్ చేయాలా?",
    "rescheduleMsg": "ఈ రిమైండర్ వాయిదా పడ్డది. మీరు దీన్ని మళ్లీ షెడ్యూల్ చేయాలనుకుంటున్నారా?",
    "reschedule15": "15 నిమిషాల్లో",
    "reschedule60": "1 గంటలో",
    "keepOverdue": "అలాగే ఉంచు"
  },
  "onboarding": {
    "slide1Title": "FishMemoryకి స్వాగతం",
    "slide1Sub": "మీ వ్యక్తిగత రిమైండర్ సహాయకుడు — WhatsApp ఆధారంగా, మీ జేబుకు అనుకూలంగా.",
    "slide2Title": "సహజంగా చాట్ చేయండి",
    "slide2Sub": "\"రేపు 3 గంటలకు అమ్మను కాల్ చేయమని గుర్తు చేయి\" అని టైప్ చేయండి — మిగతా పని మేమే చేస్తాము.",
    "slide3Title": "ఏదీ మిస్ కాకుండా ఉండండి",
    "slide3Sub": "సమయానికి నోటిఫికేషన్లు పొందండి, ట్యాగ్లతో నిర్వహించండి, మరియు ముఖ్యమైన వాటిని ఎప్పటికప్పుడు తెలుసుకోండి.",
    "getStarted": "ప్రారంభించండి",
    "next": "తర్వాతి",
    "firstReminderTitle": "మీ మొదటి రిమైండర్ సృష్టించండి!",
    "firstReminderHint": "ఇలా టైప్ చేసి చూడండి:",
    "firstReminderExample": "రేపు ఉదయం 9 గంటలకు నీళ్లు తాగమని గుర్తు చేయి",
    "gotIt": "అర్థమైంది!",
    "notifRationaleTitle": "సమయానికి ఉండండి",
    "notifRationaleBody": "FishMemory సమయానికి గుర్తు చేయడానికి నోటిఫికేషన్లు అవసరం. మీరు సృష్టించిన రిమైండర్లకే అలర్ట్లు వస్తాయి.",
    "notifRationaleAllow": "నోటిఫికేషన్లు ప్రారంభించు",
    "notifRationaleLater": "తరువాత చూడండి",
    "swipeHint": "త్వరిత చర్యల కోసం కుడి వైపు స్వైప్ చేయండి →",
    "calendarDragHint": "విస్తరించడానికి లాగ్ చేయండి ↕"
  }
}
